// Shared field configuration for the Intermittents (staff) feature.

export const GENRES = ["Monsieur", "Madame"];

export const STAFF_EMPTY = {
  matricule: "", nom: "", prenom: "", nom_naissance: "", pseudonyme: "", genre: "",
  adresse: "", complement_adresse: "", code_postal: "", ville: "", pays: "", nationalite: "",
  titre_sejour: "", expiration_titre_sejour: "", telephone: "", email: "",
  date_naissance: "", lieu_naissance: "", departement_naissance: "", pays_naissance: "",
  num_secu: "", num_conges_spectacles: "", plus_65: "", retraite: "", fiscalite: "", abattement: "",
  profession: "", type_contrat: "", date_visite_medicale: "", date_limite_visite_medicale: "",
  date_entree: "", date_anciennete: "", mode_reglement: "", iban: "", bic: "", notes: "",
  vm_en_attente: false,
  doc_synology: false, preference_poste: "", caces: "", caces_validite: "", caces_type: "",
  provenance: "", autres_zones: "", caces_doc_synology: false,
  carte_vitale_path: "", carte_vitale_name: "",
  rib_path: "", rib_name: "",
  attestation_vm_path: "", attestation_vm_name: "",
};

// Sections for the detail card & the admin modal.
export const STAFF_SECTIONS = [
  {
    title: "Identité",
    fields: [
      ["nom", "Nom"], ["prenom", "Prénom"], ["nom_naissance", "Nom de naissance"],
      ["pseudonyme", "Pseudonyme"], ["genre", "Genre"], ["date_naissance", "Date de naissance"],
      ["lieu_naissance", "Lieu de naissance"], ["departement_naissance", "Département de naissance"],
      ["pays_naissance", "Pays de naissance"], ["nationalite", "Nationalité"],
    ],
  },
  {
    title: "Coordonnées",
    fields: [
      ["email", "Email"], ["telephone", "Téléphone"], ["adresse", "Adresse"],
      ["complement_adresse", "Complément d'adresse"], ["code_postal", "Code postal"],
      ["ville", "Ville"], ["pays", "Pays"],
    ],
  },
  {
    title: "Métier & Contrat",
    fields: [
      ["matricule", "Matricule"], ["profession", "Profession"], ["type_contrat", "Type de contrat"],
      ["date_entree", "Date d'entrée"], ["date_anciennete", "Date d'ancienneté"],
    ],
  },
  {
    title: "Visite médicale",
    fields: [
      ["date_visite_medicale", "Date visite médicale"],
      ["date_limite_visite_medicale", "Date limite de prochaine visite médicale"],
    ],
  },
  {
    title: "Administratif",
    fields: [
      ["num_secu", "Numéro de sécurité sociale"], ["num_conges_spectacles", "Numéro Congés Spectacles"],
      ["titre_sejour", "Titre de séjour"], ["expiration_titre_sejour", "Expiration titre de séjour"],
      ["plus_65", "+ 65 ans"], ["retraite", "Retraité"], ["fiscalite", "Fiscalité"], ["abattement", "Abattement"],
    ],
  },
  {
    title: "Coordonnées bancaires",
    fields: [
      ["mode_reglement", "Mode de règlement"], ["iban", "IBAN"], ["bic", "BIC"],
    ],
  },
];

// Extra section for the Intermittents DB (CACES / Synology from the Google Sheet).
export const CACES_SECTION = {
  title: "CACES & Synology",
  fields: [
    ["autres_zones", "Autres zones d'intervention"],
    ["preference_poste", "Préférence de poste"],
    ["caces", "Dispose du CACES"],
    ["caces_validite", "Validité du CACES"],
    ["caces_type", "Type de CACES"],
    ["doc_synology", "Doc dans Synology"],
    ["caces_doc_synology", "Document dans Synology"],
  ],
};

// Fields shown on the public registration form are defined directly in RegistrationPage.jsx.

export const COUNTRIES = [
  "FRANCE", "AFGHANISTAN", "AFRIQUE DU SUD", "ALBANIE", "ALGERIE", "ALLEMAGNE", "ANDORRE",
  "ANGOLA", "ARABIE SAOUDITE", "ARGENTINE", "ARMENIE", "AUSTRALIE", "AUTRICHE", "BELGIQUE",
  "BENIN", "BRESIL", "BULGARIE", "BURKINA FASO", "CAMEROUN", "CANADA", "CHILI", "CHINE",
  "CHYPRE", "COLOMBIE", "CONGO", "COTE D'IVOIRE", "CROATIE", "CUBA", "DANEMARK", "EGYPTE",
  "ESPAGNE", "ESTONIE", "ETATS-UNIS", "FINLANDE", "GABON", "GEORGIE", "GRECE", "GUINEE",
  "HAITI", "HONGRIE", "INDE", "INDONESIE", "IRLANDE", "ISLANDE", "ISRAEL", "ITALIE",
  "JAPON", "LIBAN", "LITUANIE", "LUXEMBOURG", "MADAGASCAR", "MALI", "MALTE", "MAROC",
  "MAURICE", "MAURITANIE", "MEXIQUE", "MONACO", "NIGER", "NIGERIA", "NORVEGE", "PAYS-BAS",
  "PEROU", "POLOGNE", "PORTUGAL", "REPUBLIQUE TCHEQUE", "ROUMANIE", "ROYAUME-UNI", "RUSSIE",
  "RWANDA", "SENEGAL", "SERBIE", "SLOVAQUIE", "SLOVENIE", "SUEDE", "SUISSE", "SYRIE",
  "TCHAD", "THAILANDE", "TOGO", "TUNISIE", "TURQUIE", "UKRAINE", "URUGUAY", "VENEZUELA",
  "VIET NAM",
];

export function staffName(s) {
  return [s.nom, s.prenom].filter(Boolean).join(" ").trim() || "—";
}

export function staffInitials(s) {
  return [(s.nom || "")[0], (s.prenom || "")[0]].filter(Boolean).join("").toUpperCase() || "?";
}
